import { FC } from 'react'

import { MAP_CONTAINER_ID, MapActionFullscreen as View } from 'ui-components'
import { useFullscreenToggle } from '~map-preview/hooks/useFullscreenToggle'
import { useIsEmbedding } from '~map-preview/hooks/useIsEmbedding'
import { useIsFullscreen } from '~map-preview/states/ui'

export const MapEmbedFullscreenButton: FC = (props) => {
  const isEmbedding = useIsEmbedding()
  const isFullscreen = useIsFullscreen()
  const { active, toggle } = useFullscreenToggle(`#${MAP_CONTAINER_ID}`)

  if (!isEmbedding || isFullscreen) return null

  return (
    <View
      {...props}
      active={active}
      onToggle={toggle}
    />
  )
}
